<div class="height-100 bg-col-w">
    <div class="flex-column height-100 _content">
        <div class="p-b-2 _title"
             [sizeClass]="'SM: p-l-3 p-r-3 p-t-8, XL: p-l-10 p-r-10 p-t-8'">
            <div class="pos-relative">
                <!-- close button -->
                <button [attr.aria-label]="'Close' | translate"
                        class="flex flex-middle"
                        (click)="close()">
                    <i class="icon-chevron2-left _backIcon"></i>
                    <span class="m-l-2 p2">
                        Back
                    </span>
                </button>
            </div>
        </div>

        <!-- body -->
        <div class="custom-scrollbar overflow-x-hidden flex-grow _body"
             style="overflow-y: auto;">
            <div [sizeClass]="'SM: p-l-3 p-r-3, XL: p-l-10 p-r-10'">

                <p class="h4 p-t-8 col-1 center">{{ 'Select your Delivery country:' | translate }}</p>


                <type-dropdown [options]="countries()"
                               [value]="countryCode"
                               [placeholder]="'Search your country here' | translate"
                               (valueChange)="onCountrySelected($event)">
                </type-dropdown>





                @if (matchingConfiguration) {
                <p class="s2 col-1 m-t-10 _sectionTitle">{{ matchingConfiguration.custom_text }} </p>
                <p class="s2 col-1 m-t-6 _sectionTitle">{{'Delivery options:' | translate }}</p>
                @for (method of matchingConfigurationMethods!; track $index) {
                <div class="_deliveryOption">
                    <div class="flex flex-top p2 m-t-6 ">
                        <p class="flex-grow">{{ method.title }}</p>
                        <price [value]="method.price"
                               [useFreeLabel]="true" />
                    </div>
                    <p class="p3 col-11 m-t-1 hide-empty">{{ getEstimatedDate(method) }}</p>
                </div>
                }
                }


                @if (content) {
                <p class="s2 m-t-8 col-1 _sectionTitle"
                   *iCms="'returnsTitle' of content; skipEmpty: true"></p>
                <p class="p2 col-1 m-t-6 "
                   *iCms="'returnsText' of content; skipEmpty: true"></p>
                }
            </div>
        </div>

    </div>
</div>